import { Switch } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFlaky } from "react-icons/md";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const DataProtection = ({
  values,
  setFieldValue,
  errors,
  initialValues,
  formProps,
  setPercent,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", {
    returnObjects: true,
  });
  const ADDITIONAL_INFORMATION = t("SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION", {
    returnObjects: true,
  });

  const DEFAULT_QUESTIONS = {
    DEFAULT: [
      "project.fields.acceptProductStatuses",
      "project.fields.acceptFees",
      "project.fields.acceptAgreement",
    ],
    TNS: [
      "project.fields.acceptMutualRegulation",
      "project.fields.acceptMembershipRequestCopy",
      "project.fields.acceptWithdrawalTerms",
      "project.fields.confirmSocialProtectionAffiliation",
      "project.fields.confirmDeclaredActivity",
      "project.fields.confirmSocialContributionsUpToDate",
      "project.fields.commitAnnualContributionProof",
      "project.fields.ackDependentsProofObligation",
      "project.fields.confirmInformationAccuracy",
    ],
  };
  const QUESTIONS = {
    "project.fields.acceptProductStatuses": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .STATUSES_AGREEMENT
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.acceptProductStatuses",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptProductStatuses", e);
            setPercent(initialValues);
          }}
        />
      </div>
    ),
    "project.fields.acceptFees": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY.FEES}
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(initialValues, "project.fields.acceptFees")}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptFees", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.acceptAgreement": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY.AGREEMENT}
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(initialValues, "project.fields.acceptAgreement")}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptAgreement", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.acceptMutualRegulation": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .MUTUAL_REGULATION_ACK
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.acceptMutualRegulation",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptMutualRegulation", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.acceptMembershipRequestCopy": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .MEMBERSHIP_REQUEST_ACK
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.acceptMembershipRequestCopy",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptMembershipRequestCopy", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.acceptWithdrawalTerms": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .WITHDRAWAL_TERMS_ACK
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.acceptWithdrawalTerms",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.acceptWithdrawalTerms", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.confirmSocialProtectionAffiliation": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .SOCIAL_PROTECTION_AFFILIATION
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.confirmSocialProtectionAffiliation",
          )}
          onChange={(e) => {
            set(
              initialValues,
              "project.fields.confirmSocialProtectionAffiliation",
              e,
            );
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.confirmDeclaredActivity": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .DECLARED_ACTIVITY_CONFIRM
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.confirmDeclaredActivity",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.confirmDeclaredActivity", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.confirmSocialContributionsUpToDate": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .SOCIAL_CONTRIBUTIONS_UPTODATE
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.confirmSocialContributionsUpToDate",
          )}
          onChange={(e) => {
            set(
              initialValues,
              "project.fields.confirmSocialContributionsUpToDate",
              e,
            );
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.commitAnnualContributionProof": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .ANNUAL_CONTRIBUTION_PROOF
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.commitAnnualContributionProof",
          )}
          onChange={(e) => {
            set(
              initialValues,
              "project.fields.commitAnnualContributionProof",
              e,
            );
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.ackDependentsProofObligation": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .DEPENDENTS_PROOF_ACK
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.ackDependentsProofObligation",
          )}
          onChange={(e) => {
            set(
              initialValues,
              "project.fields.ackDependentsProofObligation",
              e,
            );
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
    "project.fields.confirmInformationAccuracy": (
      <div className="d-flex justify--between">
        <span className="contact-stepper__content--radio--title">
          {
            ADDITIONAL_INFORMATION.INFORMATION.MUTUAL_MOBILITY
              .INFORMATION_ACCURACY_CERT
          }
        </span>
        <Switch
          className="contact-stepper__content--radio--switch button__switch"
          checkedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.YES}
          unCheckedChildren={ADDITIONAL_INFORMATION.INFORMATION.OPTIONS.NO}
          defaultChecked={get(
            initialValues,
            "project.fields.confirmInformationAccuracy",
          )}
          onChange={(e) => {
            set(initialValues, "project.fields.confirmInformationAccuracy", e);
          }}
          onBlur={() => setPercent(initialValues)}
        />
      </div>
    ),
  };

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.DATA_PROTECTION}-section`}
    >
      <Form
        type="vertical"
        title={ADDITIONAL_INFORMATION.DATA_PROTECTION.TITLE}
      >
        <div className="grid--1">
          {DEFAULT_QUESTIONS[
            get(initialValues, "insurancePlan.fields.tns") ? "TNS" : "DEFAULT"
          ].map((info) => (
            <div key={info}>{QUESTIONS[info]}</div>
          ))}
          <Input
            type="radio"
            variant="group"
            icon={<MdOutlineFlaky size={16} />}
            label={SUBSCRIPTION.FORM.DIGITAL_OPTION.LABEL}
            values={[
              {
                value: true,
                label: SUBSCRIPTION.FORM.DIGITAL_OPTION.OPTIONS.YES,
              },
              {
                value: false,
                label: SUBSCRIPTION.FORM.DIGITAL_OPTION.OPTIONS.NO,
              },
            ]}
            value={get(initialValues, "project.contact.acceptDigital")}
            errors={errors["project.contact.acceptDigital"]}
            touched={!isEmpty(errors["project.contact.acceptDigital"])}
            onChange={(value) => {
              set(initialValues, "project.contact.acceptDigital", value);
              setPercent(initialValues);
            }}
          />
        </div>
      </Form>
    </div>
  );
};

export default DataProtection;
